import apiClient from '@lib/apiClient';

import { SharedApiUrl } from './endpoints';
import { ActiveDirectoryUser } from './types';

export const getLoggedUserInfo = async (): Promise<ActiveDirectoryUser> => {
    const response = await apiClient.get<ActiveDirectoryUser>(SharedApiUrl.ActiveDirectoryMe);
    return response.data;
};
